<template>
    <v-card flat>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn
                :loading="loading"
                :disabled="loading"
                color="purple"
                :dark="!loading"
                @click.prevent="loadData()"
            >
                {{ $t('common.update') }}
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <data-table :setup.sync="dataTable"></data-table>
    </v-card>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'inner-tab-demand-actives',
    components: {
        DataTable
    },
    data: function () {
        return {
            loading: true,
            dataTable: {
                loading: true,
                itemName: this.$t('labels.demand'),
                headers: [
                    { text: this.$t('common.tabDemands.dataTable.headers.client'), value: 'client.name', width: '10%' },
                    { text: this.$t('common.tabDemands.dataTable.headers.startDate'), value: 'startDate', width: '10%', align: 'center', date: 'iso' },
                    { text: this.$t('common.tabDemands.dataTable.headers.demand'), value: 'demand', width: '20%' },
                    { text: this.$t('common.tabDemands.dataTable.headers.currentTask'), value: 'currentTask', width: '20%', align: 'center', sortable: false },
                    { text: this.$t('common.tabDemands.dataTable.headers.nextTask'), value: 'nextTask', width: '20%', align: 'center', sortable: false },
                    { text: this.$t('common.tabDemands.dataTable.headers.deadlineDate'), value: 'deadlineDate', width: '10%', align: 'center', date: 'iso' },
                    { text: this.$t('common.tabDemands.dataTable.headers.status'), value: 'status', width: '10%', align: 'center' }
                ],
                items: [],
                totalItems: 0,
                requesterType: 'juridico',
                requesterId: undefined,
                detailTo: 'DetalheDemandaStaff',
                editTo: 'EditarDemanda',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['deadlineDate', 'client.name', 'startDate', 'status', 'demand'],
                    sortDesc: [false, false, false, false, false],
                    sortFormated: [
                        { value: 'deadlineDate', descending: false },
                        { value: 'client', descending: false },
                        { value: 'startDate', descending: false },
                        { value: 'status', descending: false },
                        { value: 'demand', descending: false }
                    ]
                },
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        async loadData () {
            await this.$helpers.sleep(0)
            this.loading = true
            this.dataTable.loading = true
            this.dataTable.items = []
            this.dataTable.requesterId = this.$route.params.id
            let endpoint = API.EndPoints.getDemandsByisDone
            let data = {
                objectId: this.$route.params.id,
                isEmployee: true,
                isDone: false,
                params: {
                    limit: this.dataTable.pagination.itemsPerPage,
                    skip: this.dataTable.pagination.page - 1,
                    order: this.dataTable.pagination.sortFormated
                }
            }
            new API(endpoint, data).request().then(response => {
                this.dataTable.items = response.body.result.items
                this.dataTable.totalItems = response.body.result.count
                this.loading = false
                this.dataTable.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>
